import { createGlobalStyle } from "styled-components";
import "@wordpress/block-library/build-style/style.css";
import { checkDarkMode, modifyColor } from "../utils/helpers";

export const GlobalStyle = createGlobalStyle`
:root {
  --input-max-width: 640px;
  --border-radius: 16px;
  --font-paragraph: ${({ theme }) => theme.fontParagraphs.fontFamily}, "sans-serif";
  --font-headings: ${({ theme }) => theme.fontHeadings.fontFamily};
  --font-links: ${({ theme }) => theme.fontLinks.fontFamily};
}

body {
  --color-primary: ${({ theme }) => theme.colors.primary};
  --color-secondary: ${({ theme }) => theme.colors.secondary};
  --color-black: ${({ theme }) => theme.colors.black};
  --color-white: ${({ theme }) => theme.colors.white};
  --color-accent1: ${({ theme }) => theme.colors.accent1};
  --color-accent2: ${({ theme }) => theme.colors.accent2};
  --color-accent3: ${({ theme }) => theme.colors.accent3};
  --color-light-gray: ${({ theme }) => theme.colors.lightGray};
  --color-dark-gray: ${({ theme }) => theme.colors.darkGray};
  --color-header-link: ${({ theme }) => theme.colors.headerLink};
  --color-body: #eee;
  --color-header-background: ${({ theme }) => theme.colors.headerBackground};
  --color-usp-icon: ${({ theme }) => theme.colors.uspIcon};
  --color-header-search
  --form-control-color: ${({ theme }) => theme.colors.primary};
  --form-control-disabled: #959495;
  --input-border: ${({ theme }) => theme.colors.accent3};
  --text-color: var(--color-black);
}

body.dark {
  --color-primary: ${({ theme }) => modifyColor(theme.colors.primary, -100)};
  --color-secondary: ${({ theme }) => modifyColor(theme.colors.secondary, -120)};
  --color-black: ${({ theme }) => theme.colors.white};
  --color-white: ${({ theme }) => theme.colors.black};
  --color-accent1: ${({ theme }) => modifyColor(theme.colors.accent1, -80)};
  --color-accent2: ${({ theme }) => modifyColor(theme.colors.accent2, -80)};
  --color-accent3: ${({ theme }) => modifyColor(theme.colors.accent3, -80)};
  --color-body: #1a1a1a;
  --form-control-color: ${({ theme }) => modifyColor(theme.colors.primary, -100)};
  --form-control-disabled: #6a6a6a;
  --input-border: ${({ theme }) => modifyColor(theme.colors.accent3, -80)};
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}
  body {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily}, "sans-serif";
    margin: 0;
    background-color: ${({ theme }) => theme.colors.white};
  }
  @media all and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {

  /* IE10+ CSS styles go here */

  }
  .breadcrumbs-wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .breadcrumbs-wrapper::-webkit-scrollbar {
    display: none;
  }
  .animate-disabled {
    transform: none !important;
    opacity: 1 !important;
    transition-duration: 0s !important;
  }
  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    margin: 60px 0;
  }
 
  a {
    color: ${({ theme }) => checkDarkMode("#000", theme)};
    font-family: ${({ theme }) => theme.fontLinks.fontFamily} , "sans-serif";
  }
  .button {
    padding: 13px 25px 11px 25px;
    font-size: 1rem;
    text-decoration: none;
    transition: 0.3s all ease-in-out;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    max-width: 300px;
    margin: 5px 10px 5px 0;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
    border: 1px solid ${({ theme }) => theme.colors.black};
    outline: none;
    &:hover {
      text-decoration: none;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.black};
      border: 1px solid #000;
    }
    &.secondary {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.white};
      &:hover {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
      }
    }
  }
  span, li, label {
    color: var(--text-color);
  }
  p {
    letter-spacing: 1px;
    line-height: 1.5;
    font-size: 1rem;
    width: 100%;
    color: var(--color-black);
    margin-top: 5px;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
      @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      font-size: 1rem !important;
    }
  }
  div {
    line-height: 1.5;
  }
  h1, h2, h3, h4 {
    width: 100%;
    margin: 5px 0;
    font-weight: unset;
    color: var(--color-black);
    font-family: ${({ theme }) => theme.fontHeadings.fontFamily}, "sans-serif";
  }
  h1 {
    font-size: clamp(1.5rem, 8vw, 3rem);
  }
  h2 {
    font-size: 2.2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      font-size: 1.75rem !important;
    }
  }
  h3 {
    font-size: 1.75rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      font-size: 1.5rem !important;
    }
  }



 main ul {
    width: 100%;
    list-style-type: none;
    li {
        &:before {
        content: "\\2022";
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 700;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
  .margin-bottom {
    margin-bottom: 20px;
  }
  .img-width {
    width: 100%;
  }
  .row-container {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.5rem;
    margin: 15px 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      flex-wrap: wrap;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: flex-start;
      flex-direction: column;
    }
  }
  .info-cards-container {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    align-items: flex-start;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      flex-flow: row wrap;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: flex-start;
      flex-flow: row wrap;
    }
  }
  .employee-card-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 1rem;
    width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
     flex-direction: column;
    }
  }
  .bus-card-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.5rem;
    margin: 30px 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      flex-wrap: wrap;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: flex-start;
      flex-direction: column;
    }
  }
  .faq-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    border: 2px solid ${({ theme }) => theme.colors.secondary};
    border-radius: 0.2rem;
  }
  .metric-wrapper {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      justify-content: space-around!important;
    }
  }
  .button-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    margin-block: 0.625rem;
    gap: 0.625rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      justify-content: center;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: center;
    }
    .bigger {
      width: 100%;
      font-size: 1.1rem;
      margin: 1rem 0;
    }
  }
  .button-margin-wide {
    margin: 5px 25px !important;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}){
      margin: 10px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      margin: 10px;
      width: 44%;
    }
  }
  .door-container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, max-content));
    padding: initial;
    justify-content: flex-start;
    @media (min-width: 700px){
      grid-template-columns: repeat(auto-fit, minmax(230px, max-content));
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.wide}){
      grid-template-columns: repeat(auto-fit, minmax(238px, max-content));
    }
  }
  .blog-container-list {
    display: flex;
    width:  100%;
    flex-flow: column wrap;
    gap: 2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      
      gap: 1rem;
    }
  }
  .blog-container-grid {
    display: flex;
    width:  100%;
    align-items: stretch;
    flex-flow: row wrap;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      justify-content: start;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      justify-content: start;
      gap: 3rem;
    }
  }
  .hero__headline {
    font-weight: 300;
    font-size: 40px;
    margin-bottom: 10px;
    text-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
  }
  .hero__subline {
    text-transform: uppercase;
    font-size: 40px;
    font-weight: 600;
    margin: 0 0 1rem 0;
    text-shadow: 0px 1px 6px rgba(0, 0, 0, 0.26);
  }
  
  .contact-container {
    height: 100vh;
    padding: 40px 0;
    justify-content: center;
    align-items: flex-start;
    margin: 0;
    width: 100%;
  }
  .contactForm {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    justify-content: flex-start;
    text-align: left;
    max-width: var(--input-max-width);
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      justify-content: center;
      flex-flow: column wrap;
      max-width: 100%;
    }
    
    #form-jenssen-ledige-stillinger{
      .fields-wrapper{
        display:flex;
        gap:30px;
        flex-wrap: nowrap;
        
        @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
          gap:0;
          flex-wrap: wrap;
        }
        
        label{
          width:50%;
          @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
            width:100%;
          }
        }
      }
    }
  }
    form {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 1rem;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      p {
        margin-bottom: 5px;
      }
    }
    label {
      width: 100%;
      display: flex;
      flex-direction: column;
      font-size: 1rem;
      
    }
    .wpcf7-list-item label { /* use this class for ALL radio and checkbox labels */
      display: grid;
      grid-template-columns: 1em auto;
      gap: 0.5em;
      line-height: 1.1;
      margin: 10px 0;
    }
    .wpcf7-list-item--disabled {
      color: var(--form-control-disabled);
      cursor: not-allowed;
    }
    
    .half-wrapper {
      display: flex;
      width: 100%;
      max-width: var(--input-max-width);
      align-items: flex-start;
      gap: 1rem;
      margin-bottom: 10px;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        max-width: 100%;
      }
    }
    .form-message {
      color: red;
    }
    p span {
      width: 100%;
    }
    hr {
      height: 2px;
      background-color: var(--input-border);
      border: none;
      width: 100%;
    }
    input[type=text],
    input[type=tel],
    input[type=email],
    input[type=date],
    input[type=password],
    input[type=time],
    textarea {
      width: 100%;
      padding: 16px;
      font-size: 1rem;
      background-color: #f7f7f7;
      border: 2px solid ${({ theme }) => theme.colors.accent3};
      border-radius: var(--border-radius);
      -webkit-appearance: none;
      font-family: var(--font-paragraph);
      color: rgb(46, 46, 46);
      @media (max-width: 1024px) {
        max-width: 100%;
      }
    }
    input[type=text]::placeholder,
    input[type=tel]::placeholder,
    input[type=email]::placeholder,
    textarea::placeholder {
      color: ${() => checkDarkMode("#b9b6b6", { isDarkMode: false })};
    }

    input:read-only {
      color: ${() => checkDarkMode("#777", { isDarkMode: false })};
      &:focus {
        outline: none;
      }
    }
   
    .wpcf7-form-control-wrap {
      width: 100%;
    }
    .phone-wrapper {
      width: 100%;
    }
    .phone-react-container {
      width: 100%;
      .PhoneInput {
        display: flex;
        width: 100%;
        align-items: flex-start;
      }
      .PhoneInputCountry {
        flex: 0 0 calc(20% - 0.25rem);
        min-width: 0;
        background-color: #f7f7f7;
        border: 2px solid ${({ theme }) => theme.colors.accent3};
        border-radius: var(--border-radius);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
        cursor: pointer;
      }
      .PhoneInputInput {
        flex: 0 0 calc(80% - 0.25rem);
        min-width: 0;
        width: calc(80% - 0.25rem);
      }
      .PhoneInputCountrySelect {
        font-family: var(--font-paragraph);
        color: rgb(46, 46, 46);
        font-size: 1rem;
      }
      .PhoneInputCountrySelect option {
        font-family: var(--font-paragraph);
        color: rgb(46, 46, 46);
        background-color: #f7f7f7;
        font-size: 1rem;
      }
    }
    .wpcf7-radio > span,
    .wpcf7-checkbox > span  {
      display: block;
      cursor: pointer;
      margin: 5px 0;
    }
    input[type=radio] {
      /* Add if not using autoprefixer */
      -webkit-appearance: none;
      appearance: none;
      /* For iOS < 15 to remove gradient background */
      background-color: #fff;
      /* Not removed via appearance */
      margin: 0;
      font: inherit;
      color: currentColor;
      width: 1.15em;
      height: 1.15em;
      border: 0.15em solid currentColor;
      border-radius: 50%;
      transform: translateY(-0.075em);
      display: grid;
      place-content: center;
    }
    input[type="radio"]::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      border-radius: 50%;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--form-control-color);
    }
    input[type="radio"]:checked {
      border: 0.15em solid var(--form-control-color);
    }
    input[type="radio"]:checked::before {
      transform: scale(0.8);
      /* Windows High Contrast Mode */
      background-color: CanvasText;
    }
    input[type=checkbox] {
      /* Add if not using autoprefixer */
      -webkit-appearance: none;
      appearance: none;
      /* For iOS < 15 to remove gradient background */
      background-color: #fff;
      /* Not removed via appearance */
      margin: 0;
      font: inherit;
      color: currentColor;
      width: 1.15em;
      height: 1.15em;
      border: 0.15em solid currentColor;
      border-radius: 0.15em;
      transform: translateY(-0.065em);
      display: grid;
      place-content: center;
    }
    input[type="checkbox"]::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em #fff;
      transform-origin: bottom left;
      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    }
    input[type="checkbox"]:checked {
      background-color: currentColor;
    }
    input[type="checkbox"]:checked::before {
      transform: scale(1);
       /* Windows High Contrast Mode */
      background-color: CanvasText;
    }
    
    input[type=submit] {
      border: none;
      width: 200px;
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      font-size: 1rem;
      line-height: initial;
      text-decoration: none;
      transition: 0.3s all ease-in-out;
      font-family: var(--font-paragraph);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      border-radius: var(--border-radius);
      &:disabled {
        background-color: ${({ theme }) => checkDarkMode("#949494", theme)} !important;
        color: ${({ theme }) => checkDarkMode("#ededed", theme)} !important;
        cursor: not-allowed !important;
      }

      &:first-child {
        margin-left: 0;
      }
      @media (hover: hover) {
        &:hover {
          text-decoration: none;
          cursor: pointer;
          background-color: ${({ theme }) =>
            modifyColor(theme.colors.primary, -40)};
        }
      }
       @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        width: 100%;
        padding: 12px 64px;
      }
    }
    textarea {
      height: 150px;
      resize: none;
      min-width: var(--input-max-width);
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        min-width: unset;
      }
    }
    input[type="number"] {
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      appearance: textfield;
      font-family: var(--font-paragraph);
      width: 100%;
      padding: 0.5rem;
      margin-block: 5px;
      background-color: ${({ theme }) => checkDarkMode("#f7f7f7", theme)};
      border: 2px solid var(--input-border);
      border-radius: var(--border-radius);
      font-size: 1rem;
      height: 4.5rem;
      font-weight: bold;
      text-align: center;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
    .checkbox-text {
      font-size: 10px;
      margin-left: 0.5rem;
    }
    .form-input-required-message {
      margin-top: 0px;
      color: red;
      font-size: 0.8rem;
    }
  
  .active-product-link {
    border-bottom: 3px solid ${({ theme }) => theme.colors.primary};
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      border: 1px solid ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
    }
  }
  .center {
    text-align: center;
    justify-content: center;
  }
  .wp-block-media-text {
    margin-bottom: 40px;
  }
  .wp-block-media-text:last-child {
    margin-bottom: 0;
  }

  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      padding: 0;
    }
  }
  .CookieConsent {
    align-items: baseline;
    background: rgb(53, 53, 53) none repeat scroll 0% 0%;
    color: white;
    display: flex;
    flex-wrap: wrap;
    line-height: 1.4;
    justify-content: space-between;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    left: 0px;
    position: fixed;
    width: 100%;
    z-index: 999;
    bottom: 0px;
    padding: 10px;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      & div {
        display: flex;
      }
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    & button {
      &:nth-child(2) {
        @media (hover: hover) {
          &:hover {
            background-color: transparent;
            border-color: ${({ theme }) => checkDarkMode("#fefefe", theme)};
            color:  ${({ theme }) => checkDarkMode("#fefefe", theme)};
          }
        }
      }
    }
  }
  .cover {
    height: 100%;
  }

   //Override some carousel styles
  .carousel-root ul li {
    &:before {
      content: none !important;
    }
  }
   .carousel div {
     width: 100%;
     height: 100%;
   }

   .carousel.carousel-slider {
    overflow: visible !important;
  }

  .carousel .control-dots {
    bottom: -35px !important;
    padding: 0 1rem !important;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    .control-dots {
      z-index: 0!important;
    }
    .carousel img {
      min-height: 40vh !important;
    }
    .read-more {
      display: flex;
      align-items: flex-end;
      text-align: center;
      width: 100%;
      height: 100px;
      margin-top: -45px!important;
      z-index: 1000;
      background: rgb(255,255,255);
      background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(251,251,251,0.5021358885351015) 100%);
    }
    .no-read-more {
      margin-top: 0!important;
      text-align: center;
    }
  }

  .is-style-rounded {
    border-radius: var(--border-radius);
  }

  .react-tooltip-arrow {
    font-weight: 600; !important;
    font-size: 14px !important;
    border-radius: 8px !important;
    @media (min-width: ${({ theme }) => theme.breakpoints.phone}){
      left: 35px !important;
    }
  }

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  .border-radius-32 {
    border-radius: 32px;
  }
  
  .h-send-oss-en-henvendelse {
    padding: 0 20px;
  }

  .small-inline-icon {
    img {
      height: 36px;
      width: 36px;
    }
  }

  .image-with-border-radius {
    border-radius: 12px;
  }

  .dark-mode-container-with-links {
  ${({ theme }) => (theme.isDarkMode ? "background-color: #242424;" : "")}
    > div {
      ${({ theme }) => (theme.isDarkMode ? "background-color: #242424;" : "")}
    }
  }

  ${({ theme }) => theme.customCSS}
`;
